module.exports = __webpack_public_path__ + "img/enerman-etsol.df1f8912.svg";